module.exports = __webpack_public_path__ + "media/images/Branding/HW Mark 2-7b99cbdb456827f4ac235399f0e34e61.png";